export default __webpack_public_path__ + "static/media/iq.f995df61.svg";